import React from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';

import { useStyles } from '~/assets/styles';
import CardDialog from '~/components/CardDialog';
import Button from '~/components/core/Atomic/Buttons/Button';
import CancelButton from '~/components/core/Buttons/CancelButton';
import { createPhoneProfile } from '~/components/SystemConfiguration/Communications/PhoneConfigurationTab/phoneProfilesApi';
import TextFieldFormik from '~/components/TextFieldFormik';
import { reportAxiosError } from '~/Utils';

interface FormValues {
  name: string;
}

interface CreateProfileDialogProps {
  isOpen: boolean;
  organizationId: number;
  onClose: () => void;
  onCreated: (newProfileId: number) => void;
}

const CreateProfileDialog: React.FC<CreateProfileDialogProps> = ({ isOpen, organizationId, onClose, onCreated }) => {
  const { classes } = useStyles();

  if (!isOpen) {
    return null;
  }

  return (
    <Formik<FormValues>
      initialValues={{ name: '' }}
      validationSchema={Yup.object().shape({
        name: Yup.string().trim().required('Name is required'),
      })}
      onSubmit={async (values, formikProps) => {
        try {
          const newProfile = await createPhoneProfile(organizationId, { name: values.name.trim() });
          onCreated(newProfile.id);
        } catch (error) {
          reportAxiosError(error);
          formikProps.setSubmitting(false);
        }
      }}
    >
      {({ isSubmitting, handleSubmit }) => (
        <CardDialog
          title="Create phone profile"
          isDialog
          maxWidth="sm"
          fullWidth
          onClose={onClose}
          preventClose={isSubmitting}
        >
          <TextFieldFormik id="name" label="Profile name" fullWidth autoFocus />
          <div className={classes.buttonsContainer}>
            <CancelButton disabled={isSubmitting} onClick={onClose} />
            <Button
              variant="contained"
              color="primary"
              disabled={isSubmitting}
              onClick={(e) => {
                e.preventDefault();
                handleSubmit();
              }}
            >
              Create
            </Button>
          </div>
        </CardDialog>
      )}
    </Formik>
  );
};

export default CreateProfileDialog;
